import { store } from '@/store/store'
import Vue from 'vue'
import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_GESCON_SEF_URL}${process.env.VUE_APP_API_PATH}`

export default {
    ListarConvenios() {
        return axiosJwt
            .get(`${api}/gescon/gestor/convenio/ListarConveniosPorGestor`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    ObterConvenioPorId(id) {
        return axiosJwt
            .get(`${api}/gescon/gestor/convenio/ObterConvenioPorId/${id}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    ListarPrestacoesContas(idConvenio) {
        return axiosJwt
            .get(`${api}/gescon/gestor/convenio/ListarPrestacoesMensais/${idConvenio}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    EnviarPrestacaoMensal(idPrestacaoMensal) {
        return axiosJwt.post(`${api}/gescon/gestor/convenio/enviarprestacaomensal/${idPrestacaoMensal}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    ObterPrestacaoMensal(id) {
        return axiosJwt
            .get(`${api}/gescon/gestor/convenio/ObterPrestacaoMensal/${id}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    InserirPrestacaoMensal(prestacao) {
        return axiosJwt.post(`${api}/gescon/gestor/convenio/InserirPrestacaoMensal`, prestacao)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    ExcluirPrestacaoMensal(id) {
        return axiosJwt
            .get(`${api}/gescon/gestor/convenio/ExcluirPrestacaoMensal/${id}`)
            .catch(error => {
                return errorHandler(error)
            })
    },

    ListarPrestacoesFinais(idPrestacaoMensal) {
        return axiosJwt
            .get(`${api}/gescon/gestor/convenio/ListarPrestacoesFinais/${idPrestacaoMensal}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    ListarAcoes(idConvenio) {
        return axiosJwt
            .get(`${api}/gescon/gestor/convenio/ListarAcoes/${idConvenio}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    ListarNaturesasPorAcoes(idConvenio, idAcao) {
        return axiosJwt
            .get(`${api}/gescon/gestor/convenio/ListarNaturesasPorAcoes/${idConvenio}/${idAcao}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    InserirPrestacaoFinal(prestacao) {
        return axiosJwt.post(`${api}/gescon/gestor/convenio/InserirPrestacaoFinal`, prestacao)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    AtualizarPrestacaoFinal(prestacao) {
        return axiosJwt.post(`${api}/gescon/gestor/convenio/AtualizarPrestacaoFinal`, prestacao)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    ExcluirPrestacaoFinal(id) {
        return axiosJwt
            .get(`${api}/gescon/gestor/convenio/ExcluirPrestacaoFinal/${id}`)
            .catch(error => {
                return errorHandler(error)
            })
    },

    ListarDocumentosPrestacaoFinal(idPrestacaoFinal) {
        return axiosJwt
            .get(`${api}/gescon/gestor/convenio/ListarDocumentosPrestacoesFinais/${idPrestacaoFinal}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTiposDocumentos() {
        return axiosJwt
            .get(`${api}/gescon/gestor/convenio/ListarTiposDocumentos`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    ObterImpostos() {
        return axiosJwt
            .get(`${api}/gescon/gestor/convenio/impostos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirDocumentosPrestacaoFinal(documento) {
        const formData = new FormData()
        formData.append('id_Documento', documento.id_Documento)
        formData.append('id_Convenio', documento.id_Convenio)
        formData.append('idPrestacaoContasFinal', documento.idPrestacaoContasFinal)
        formData.append('id_TipoDocumento', documento.id_TipoDocumento)
        formData.append('vcDescricaoDocumento', documento.vcDescricaoDocumento)
        formData.append('vcNomeArquivo', documento.vcNomeArquivo)
        formData.append('arquivo', documento.arquivo)

        return axiosJwt.post(`${api}/gescon/gestor/convenio/InserirDocumentoConvenio`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    ExcluirDocumentoConvenio(id) {
        return axiosJwt
            .get(`${api}/gescon/gestor/convenio/ExcluirDocumentoConvenio/${id}`)
            .catch(error => {
                return errorHandler(error)
            })
    },

    downloadDocumento(id) {
        return axiosJwt
            .get(
                `${api}/gescon/gestor/convenio/DownloadDocumentoPorId/${id}`,
                {
                    responseType: 'blob'
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterRelatorio(idConvenio, relatorio) {
        return axiosJwt
            .get(`${api}/gescon/gestor/convenio/${idConvenio}/relatorios/${relatorio}`, { responseType: 'blob' })
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    ObterAcoesPlanoTrabalho(idConvenio) {
        return axiosJwt
            .get(`${api}/gescon/gestor/convenio/obteracoesplanotrabalho/${idConvenio}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirAcaoPlanoTrabalho(acao) {
        return axiosJwt.post(`${api}/gescon/gestor/convenio/inseriracaoplanotrabalho`, acao)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    cancelarAcaoPlanoTrabalho(id) {
        return axiosJwt
            .get(`${api}/gescon/gestor/convenio/cancelaracaoplanotrabalho/${id}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    alterarAcaoPlanoTrabalho(acao) {
        return axiosJwt.post(`${api}/gescon/gestor/convenio/alteraracaoplanotrabalho`, acao)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterEventosPorAcao(id) {
        return axiosJwt
            .get(`${api}/gescon/gestor/convenio/acaoplanotrabalho/${id}/eventos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    obterConsultoriasPorAcao(id) {
        return axiosJwt
            .get(`${api}/gescon/gestor/convenio/acaoplanotrabalho/${id}/consultorias`)
            .then(response => {
                return response.data

            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    obterEntregasPorAcao(id) {
        return axiosJwt
            .get(`${api}/gescon/gestor/convenio/acaoplanotrabalho/${id}/entregas`)
            .then(response => {
                return response.data

            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    cancelarEvento(id) {
        return axiosJwt
            .get(`${api}/gescon/gestor/convenio/cancelarevento/${id}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirEvento(evento) {
        return axiosJwt.post(`${api}/gescon/gestor/convenio/inserirevento`, evento)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },
    inserirConsultoria(consultoria) {
        return axiosJwt.post(`${api}/gescon/gestor/convenio/inserirconsultoria`, consultoria)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },
    inserirEntrega(entrega) {
        return axiosJwt.post(`${api}/gescon/gestor/convenio/inserirentrega`, entrega)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },
    inserirMetaConsultoria(consultoria) {
        return axiosJwt.post(`${api}/gescon/gestor/convenio/inserirmetaconsultoria`, consultoria)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    inserirMetaEntrega(entrega) {
        return axiosJwt.post(`${api}/gescon/gestor/convenio/inserirmetaentrega`, entrega)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },
    inserirHistoricoSas(historico) {
        return axiosJwt.post(`${api}/gescon/gestor/convenio/inserirhistoricosas`, historico)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },
    alterarConsultoria(consultoria) {
        return axiosJwt.post(`${api}/gescon/gestor/convenio/alterarconsultoria`, consultoria)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },
    alterarEntrega(entrega) {
        return axiosJwt.post(`${api}/gescon/gestor/convenio/alterarentrega`, entrega)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },
    alterarEvento(evento) {
        return axiosJwt.post(`${api}/gescon/gestor/convenio/alterarevento`, evento)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },
    obterDocumentosMetaConsultoria(idMetaConsultoria) {
        return axiosJwt
            .get(`${api}/gescon/gestor/convenio/obterdocumentosmetaconsultoria/${idMetaConsultoria}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    obterDocumentosMetaEntrega(idMetaEntrega) {
        return axiosJwt
            .get(`${api}/gescon/gestor/convenio/obterdocumentosmetaentrega/${idMetaEntrega}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    inserirDocumentoMetaEntrega(documento) {
        const formData = new FormData()
        formData.append('idMetaEntrega', documento.idMetaEntrega)
        formData.append('vcNomeArquivo', documento.vcNomeArquivo)
        formData.append('arquivo', documento.arquivo)
        formData.append('descricaoArquivo', documento.descricaoArquivo)
        return axiosJwt.post(`${api}/gescon/gestor/convenio/inserirdocumentometaentrega`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        })
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    excluirDocumentoMetaEntrega(idDocumentoMetaEntrega) {
        return axiosJwt
            .get(`${api}/gescon/gestor/convenio/excluirdocumentometaentrega/${idDocumentoMetaEntrega}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    downloadDocumentoMetaEntrega(idMetaEntrega, idDocumento) {
        return axiosJwt
            .get(`${api}/gescon/gestor/convenio/downloaddocumentometaentrega/${idMetaEntrega}/${idDocumento}`, { responseType: 'blob' })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    inserirDocumentoMetaConsultoria(documento) {
        const formData = new FormData()
        formData.append('idMetaConsultoria', documento.idMetaConsultoria)
        formData.append('vcNomeArquivo', documento.vcNomeArquivo)
        formData.append('arquivo', documento.arquivo)
        formData.append('descricaoArquivo', documento.descricaoArquivo)
        return axiosJwt.post(`${api}/gescon/gestor/convenio/inserirdocumentometaconsultoria`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        })
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    excluirDocumentoMetaConsultoria(idDocumentoMetaConsultoria) {
        return axiosJwt
            .get(`${api}/gescon/gestor/convenio/excluirdocumentometaconsultoria/${idDocumentoMetaConsultoria}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    downloadDocumentoMetaConsultoria(idMetaConsultoria, idDocumento) {
        return axiosJwt
            .get(`${api}/gescon/gestor/convenio/downloaddocumentometaconsultoria/${idMetaConsultoria}/${idDocumento}`, { responseType: 'blob' })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    obterDocumentosEvento(idEvento) {
        return axiosJwt
            .get(`${api}/gescon/gestor/convenio/obterdocumentosevento/${idEvento}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    obterMetasConsultoria(idConsultoria) {
        return axiosJwt
            .get(`${api}/gescon/gestor/convenio/${idConsultoria}/obtermetasconsultoria`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    obterMetasEntrega(idEntrega) {
        return axiosJwt
            .get(`${api}/gescon/gestor/convenio/${idEntrega}/obtermetasentrega`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },


    inserirDocumentoEvento(documento) {
        const formData = new FormData()
        formData.append('idEvento', documento.idEvento)
        formData.append('vcNomeArquivo', documento.vcNomeArquivo)
        formData.append('arquivo', documento.arquivo)
        formData.append('descricaoArquivo', documento.descricaoArquivo)
        return axiosJwt.post(`${api}/gescon/gestor/convenio/inserirdocumentoevento`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        })
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    excluirDocumentoEvento(idDocumentoEvento) {
        return axiosJwt
            .get(`${api}/gescon/gestor/convenio/excluirdocumentoevento/${idDocumentoEvento}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    downloadDocumentoEvento(idEvento, idDocumento) {
        return axiosJwt
            .get(`${api}/gescon/gestor/convenio/downloaddocumentoevento/${idEvento}/${idDocumento}`, { responseType: 'blob' })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterMetas(idEvento) {
        return axiosJwt
            .get(`${api}/gescon/gestor/convenio/${idEvento}/obtermetas`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    cancelarMeta(id) {
        return axiosJwt
            .get(`${api}/gescon/gestor/convenio/cancelarmeta/${id}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirMeta(meta) {
        return axiosJwt.post(`${api}/gescon/gestor/convenio/inserirmeta`, meta)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterTiposInstrumento() {
        return axiosJwt
            .get(`${api}/gescon/gestor/convenio/obtertiposinstrumento`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    obterAcoesSas() {
        return axiosJwt
            .get(`${api}/gescon/gestor/convenio/obteracoessas`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    obterProjetosSas() {
        return axiosJwt
            .get(`${api}/gescon/gestor/convenio/obterprojetossas`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    obterTemasSas() {
        return axiosJwt
            .get(`${api}/gescon/gestor/convenio/obtertemassas`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterGestores() {
        return axiosJwt
            .get(`${api}/gescon/gestor/convenio/gestores`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterUnidades() {
        return axiosJwt
            .get(`${api}/gescon/gestor/convenio/unidades`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
}
